import { render } from "./Temuan.vue?vue&type=template&id=a2cb0668"
import script from "./Temuan.vue?vue&type=script&lang=js"
export * from "./Temuan.vue?vue&type=script&lang=js"

import exportComponent from "E:\\WEB-APPS\\gizkia\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__